import React, { Component } from 'react'
import TodoItem from './TodoItem';
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import './TodoListStyles.css';


export default class TodoList extends Component {
    render() {
        const {items, checkedItems, determineDeleteAction, /*clearList,*/ handleChecked, handleEdit, handleDelete, handleCompleted, determineCompletedAction} = this.props

        return (
            <div className="card card-body my-3">
                <h3 className="text-capitalize text-center">Task Items</h3>
                <ul className="list-group my-2">
                    {
                        items.map(item => {
                            return (
                                <TodoItem key={item.id} title={item.title} completedDate={item.completedDate} isChecked={item.isChecked}
                                handleChecked={() => handleChecked(item.id)}
                                handleEdit={() => handleEdit(item.id)}
                                handleDelete={() => handleDelete(item.id)}
                                handleCompleted={() => handleCompleted(item.id)}/>
                            );
                        })
                    }
                </ul>

                {/*<button type="button" className="btn btn-danger btn-block text-capitalize mt-4" onClick={clearList}>Clear list</button>*/}

                <AwesomeButton type="primary"
                    onPress={() => {
                        determineCompletedAction();
                        //markAllCompleted();
                    }}
                    className="btn-block mt-3">
                        {checkedItems && checkedItems.length ? 'Mark selected items as completed' : 'Mark all items as completed'}
                </AwesomeButton>

                <AwesomeButton type="primary"
                    onPress={() => {
                        determineDeleteAction();
                        //clearList();
                    }}
                    className="danger btn-block mt-3">
                        {checkedItems && checkedItems.length ? 'Delete selected Items' : 'Clear List'}
                </AwesomeButton>
            </div>
        )
    }
}
